module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki09_pc-130862e53d43926ac85129232878c485.jpg";